import SideDrawer from "./SideDrawer";
import TopBar from "./TopBar";
import Footer from "./Footer";
import { Box, useMediaQuery } from "@mui/material";

const FOOTER_HEIGHT = 80;

const Layout = ({ children }) => {
  const isMobile = useMediaQuery("(max-width:899px)");

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Sidebar - only on desktop */}
      {!isMobile && <SideDrawer />}

      {/* Main content area */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          height: "100vh",
          overflow: "hidden",
        }}
      >
        {/* TopBar with hamburger menu - only on mobile/tablet */}
        {isMobile && <TopBar />}

        {/* Scrollable content */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
          }}
        >
          {children}
        </Box>

        {/* Fixed footer */}
        <Box
          sx={{
            height: FOOTER_HEIGHT,
            flexShrink: 0,
          }}
        >
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
